import React, { useState, useEffect } from "react";
import {
  Button,
  TextField,
  Modal,
  Box,
  Typography,
  Slide,
  Grid,
  Card,
  CardContent,
  IconButton,
  Select,
  MenuItem,
  FormControl,
  InputAdornment,
  OutlinedInput,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  TextareaAutosize,
  ListItemText,
  Menu,
} from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import DatePicker from "../../../../Components/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import {
  AddPhotoAlternate,
  DeleteOutline,
  AddCircleOutline,
  RemoveCircleOutline,
  SaveOutlined,
  DoneAllOutlined,
  Send,
} from "@mui/icons-material";
import {
  clientInvoiceApis,
  financeSettingsApi,
  BusinessSettingsApi,
  taxSettingsApi,
} from "../../../../Data/axios";
import config from "../../../../Data/AuthUser";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { styled } from "@mui/material/styles";

export default function AddInvoice({
  open,
  handleClose,
  onInvoiceAdded,
  clientData,
}) {
  // State variables from InvoiceClients
  const [startDate, setStartDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [invoiceValue, setInvoiceValue] = useState(null);
  const [invoiceStatus, setInvoiceStatus] = useState(null);
  const [payDetail, setPayDetail] = useState(null);
  const [about, setAbout] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [currencyValue, setCurrencyValue] = useState([]);
  const [businessLocation, setBusinessLocation] = useState([]);
  const [currencyItem, setCurrencyItem] = useState("");
  const [locationValue, setLocationValue] = useState("");
  const [taxType, setTaxType] = useState(null);
  const [shippingAddress, setShippingAddress] = useState("");
  const [note, setNote] = useState("");
  const [terms, setTerms] = useState("");
  const [hide, setHide] = useState(false);
  const [rows, setRows] = useState([
    {
      quantity: "",
      unit: "1",
      unitPrice: "",
      tax: [],
      amount: "0.00",
    },
  ]);
  const [subtotal, setSubtotal] = useState(0);
  const [total, setTotal] = useState(0);
  const [discountValue, setDiscountValue] = useState("");
  const [discountType, setDiscountType] = useState("2");
  const [descriptions, setDescriptions] = useState([]);
  const [items, setItems] = useState([]);
  const [files, setFiles] = useState([]);
  const [optionsValue, setOptionsValue] = useState([]);
  const [invoicePrefix, setInvoicePrefix] = useState("");
  const [invoiceSeparator, setInvoiceSeparator] = useState("");
  const [invoiceDigits, setInvoiceDigits] = useState("");
  const [anchorEl1, setAnchorEl1] = useState(null);
  const [taxOptions, setTaxOptions] = useState([]);
  const open1 = Boolean(anchorEl1);

  const StyledCheckBoxOutlineBlankIcon = styled(CheckBoxOutlineBlankIcon)({
    fontSize: "1.5rem",
  });

  const StyledCheckBoxIcon = styled(CheckBoxIcon)({
    fontSize: "1.5rem",
  });

  // Tax options
  //   const taxOptions = [
  //     { id: 1, label: "GST: 10%", rate: 10 },
  //     { id: 2, label: "CGST: 18%", rate: 18 },
  //     { id: 3, label: "VAT: 5%", rate: 5 },
  //   ];

  // Fetch initial data when component mounts
  useEffect(() => {
    fetchTaxSettings();
    fetchFinanceSettings();
    fetchCurrencyData();
    fetchBusinessData();
    if (clientData?.user_id) {
      fetchClientDriver(clientData.user_id);
    }
  }, [clientData]);

  // Calculate subtotal and total
  useEffect(() => {
    const subtotalValue = rows.reduce(
      (acc, row) => acc + parseFloat(row.amount || 0),
      0
    );
    setSubtotal(subtotalValue);
  }, [rows]);

  useEffect(() => {
    let discountAmount = 0;
    if (discountType === "percent") {
      discountAmount = (subtotal * discountValue) / 100;
    } else {
      discountAmount = parseFloat(discountValue) || 0;
    }
    const totalValue = subtotal - discountAmount;
    setTotal(totalValue.toFixed(2));
  }, [subtotal, discountValue, discountType]);

  const fetchTaxSettings = async () => {
    try {
      const response = await taxSettingsApi.getAll();
      if (response && Array.isArray(response)) {
        // Map API response to the format expected by your component
        const formattedTaxOptions = response.map((tax) => ({
          id: tax.id,
          label: `${tax.tax_name}: ${tax.rate}%`,
          rate: parseFloat(tax.rate) || 0,
        }));
        setTaxOptions(formattedTaxOptions);
      }
    } catch (error) {
      console.error("Error fetching tax settings:", error);
    }
  };
  // Fetch finance settings
  const fetchFinanceSettings = async () => {
    try {
      const response = await financeSettingsApi.getAll();
      const settings = response[0];
      setInvoicePrefix(settings.invoice_prefix || "");
      setInvoiceSeparator(settings.invoice_start_separator || "");
      setInvoiceDigits(settings.Invoice_digits || "");
    } catch (error) {
      console.error("Error fetching finance settings:", error);
    }
  };

  // Fetch currency data
  const fetchCurrencyData = async () => {
    try {
      const response = await financeSettingsApi.getAllCurrency();
      setCurrencyValue(response);
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };

  // Fetch business data
  const fetchBusinessData = async () => {
    try {
      const response = await BusinessSettingsApi.getAll();
      setBusinessLocation(response.data);
    } catch (error) {
      console.error("Error fetching business data:", error);
    }
  };

  // Fetch client driver data
  const fetchClientDriver = async (userId) => {
    try {
      const response = await clientInvoiceApis.clientDriverById(userId);
      if (response && response.data) {
        setOptionsValue(response.data);
      }
    } catch (error) {
      console.error("Error fetching client drivers:", error);
    }
  };

  // Generate invoice number example
  const generateExample = (prefix, separator, digits) => {
    const digitCount = parseInt(digits, 10);
    if (isNaN(digitCount) || digitCount < 1) {
      return "";
    }
    const number = String("0".repeat(digitCount - 1) + "1").slice(-digitCount);
    return `${prefix}${separator}${number}`;
  };

  // Form utilities
  const handleFormReset = () => {
    setStartDate(null);
    setDueDate(null);
    setUploadFile(null);
    setInvoiceValue(null);
    setInvoiceStatus(null);
    setPayDetail(null);
    setAbout(false);
    setInputValue("");
    setCurrencyItem("");
    setLocationValue("");
    setTaxType(null);
    setShippingAddress("");
    setNote("");
    setTerms("");
    setDiscountValue("");
    setDiscountType("2");
    setDescriptions([]);
    setItems([]);
    setFiles([]);
    setRows([
      {
        quantity: "",
        unit: "1",
        unitPrice: "",
        tax: [],
        amount: "0.00",
      },
    ]);
  };

  const handleCloseModal = () => {
    handleFormReset();
    handleClose();
  };

  // Input handlers
  const handleInputChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;

    // Update amount when quantity, unitPrice, or tax changes
    if (field === "quantity" || field === "unitPrice" || field === "tax") {
      const quantity = parseFloat(updatedRows[index].quantity) || 0;
      const unitPrice = parseFloat(updatedRows[index].unitPrice) || 0;

      // Calculate base amount without tax
      let baseAmount = quantity * unitPrice;

      // Calculate tax amount based on selected tax IDs
      const taxAmount = updatedRows[index].tax.reduce((acc, taxId) => {
        const selectedTax = taxOptions.find((tax) => tax.id === taxId);
        if (selectedTax) {
          return acc + (baseAmount * selectedTax.rate) / 100;
        }
        return acc;
      }, 0);

      // Calculate total amount including tax
      const amount = baseAmount + taxAmount;
      updatedRows[index].amount = amount.toFixed(2);
    }

    setRows(updatedRows);
  };

  const handleInputChangeInvoice = (event) => {
    setInputValue(event.target.value);
  };

  const handleDescriptionChange = (index, value) => {
    const newDescriptions = [...descriptions];
    newDescriptions[index] = value;
    setDescriptions(newDescriptions);
  };

  const handleItemsChange = (index, value) => {
    const newItems = [...items];
    newItems[index] = value;
    setItems(newItems);
  };

  const handleFileChangeMain = (index, event) => {
    const newFiles = [...files];
    newFiles[index] = event.target.files[0];
    setFiles(newFiles);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setUploadFile(file);
  };

  const handleAddressChange = (event) => {
    setShippingAddress(event.target.value);
  };

  const handleNoteChange = (event) => {
    setNote(event.target.value);
  };

  const handleTermsChange = (event) => {
    setTerms(event.target.value);
  };

  const handleStartDateChange = (newStartDate) => {
    setStartDate(newStartDate);
  };

  const handleDueDateChange = (newDueDate) => {
    setDueDate(newDueDate);
  };

  const handleClickNew = () => {
    setHide((prev) => !prev);
  };

  const handleClick1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handleClose1 = () => {
    setAnchorEl1(null);
  };

  // Row management
  const addRow = () => {
    setRows([
      ...rows,
      {
        quantity: "",
        unit: "1",
        unitPrice: "",
        tax: [],
        amount: "",
      },
    ]);
  };

  const removeRow = (index) => {
    const updatedRows = rows.filter((row, i) => i !== index);
    setRows(updatedRows);
  };

  // Time converter utility
  const timeConverter = (value) => {
    const date = new Date(value);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    };
    const formattedDate = date
      .toLocaleString("en-GB", options)
      .replace(",", "");
    return formattedDate.replace(/\//g, "-");
  };

  // Handle save functionality
  const handleSaveInvoice = async (status) => {
    try {
      const concatenatedValue = `${generateExample(
        invoicePrefix,
        invoiceSeparator,
        invoiceDigits
      )}${inputValue}`;

      // Create FormData for handling file uploads
      const formData = new FormData();

      // Prepare array of items
      const arrayValue = [];
      if (Array.isArray(rows)) {
        rows.forEach((row, index) => {
          if (row) {
            const obj = {
              item: items[index] || "",
              description: descriptions[index] || "",
              quality_type: row.unit || "",
              quantity: row.quantity || "",
              unit_price: row.unitPrice || "",
              amount: row.amount || "0",
              tax: Array.isArray(row.tax) ? row.tax.map(String) : [],
              file: files[index] || null,
            };
            arrayValue.push(obj);
          }
        });
      }

      const updatedArray = arrayValue.map((item) => ({
        ...item,
        tax: Array.isArray(item.tax) ? item.tax.map(String) : [],
      }));

      // Append all basic fields
      formData.append("client_id", clientData?.user_id);
      formData.append("authorized_by", "1202");
      formData.append("invoice_to", status === 4 ? 1 : 0); // Mark as paid if status is 4
      formData.append("save_status", status);
      formData.append("paid_on", "2024-09-30");
      formData.append("paid_date", "2024-09-30");
      formData.append("invoice_number", concatenatedValue);

      // Only append dates if they exist
      if (startDate) formData.append("Invoice_date", timeConverter(startDate));
      if (dueDate) formData.append("due_date", timeConverter(dueDate));

      // Append other fields
      if (currencyItem) formData.append("currency", currencyItem);
      if (shippingAddress) formData.append("shipping_address", shippingAddress);
      if (discountType) formData.append("discount_id", discountType);
      if (payDetail) formData.append("payment_details", payDetail);
      if (taxType) formData.append("calcuated_tax", taxType);

      // Get creator from localStorage
      const userDataNew = localStorage.getItem("user-info");
      let creator = "";
      if (userDataNew) {
        const parsedData = JSON.parse(userDataNew);
        creator = parsedData.value.empid;
      }

      if (creator) formData.append("created_by", creator);
      if (note) formData.append("note", note);
      if (terms) formData.append("terms", terms);
      if (discountValue) formData.append("discount", discountValue);
      if (total) formData.append("total_amount", total);
      if (total) formData.append("paid_amount", total);
      if (locationValue) formData.append("Generated_by", locationValue);

      // Append main file if exists
      if (uploadFile) formData.append("file", uploadFile);

      // Append items as JSON string
      formData.append("items", JSON.stringify(updatedArray));

      // Add files separately
      updatedArray.forEach((item, index) => {
        if (files[index]) {
          formData.append(`item_files[${index}]`, files[index]);
        }
      });

      // Send the request
      await clientInvoiceApis.add(formData);
      if (onInvoiceAdded) onInvoiceAdded();
      handleCloseModal();
    } catch (error) {
      console.error("Error saving invoice:", error);
      alert(
        `Failed to save invoice: ${
          error.response?.data?.message || error.message
        }`
      );
    }
  };

  return (
    <Modal open={open} onClose={handleCloseModal} closeAfterTransition>
      <Slide direction="left" in={open}>
        <Box
          sx={{
            position: "absolute",
            top: 0,
            right: 0,
            width: "85%",
            height: "100%",
            bgcolor: "#f5f5f5",
            boxShadow: 24,
            p: 4,
            overflow: "auto",
            fontFamily: "Ubuntu, sans-serif",
          }}
        >
          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
          >
            <Typography
              variant="h3"
              component="h2"
              sx={{ color: "#212121", fontFamily: "Ubuntu, sans-serif" }}
            >
              New Invoice
            </Typography>
            <Button
              onClick={handleCloseModal}
              variant="outlined"
              sx={{
                borderColor: "#bdbdbd",
                color: "#424242",
                "&:hover": {
                  borderColor: "#9e9e9e",
                  bgcolor: "rgba(0, 0, 0, 0.04)",
                },
                fontFamily: "Ubuntu, sans-serif",
              }}
            >
              Close
            </Button>
          </Box>
          <Card
            sx={{
              p: 2,
              bgcolor: "#ffffff",
              boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.08)",
            }}
          >
            <CardContent>
              <Box sx={{ mb: 4 }}>
                <Grid container spacing={3}>
                  {/* Invoice Number */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Invoice Number <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl variant="outlined" fullWidth>
                      <OutlinedInput
                        value={inputValue}
                        onChange={handleInputChangeInvoice}
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                          color: "#000000",
                        }}
                        startAdornment={
                          <InputAdornment position="start">
                            <Typography
                              variant="body2"
                              sx={{
                                color: "#757575",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              {generateExample(
                                invoicePrefix,
                                invoiceSeparator,
                                invoiceDigits
                              )}
                            </Typography>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </Grid>

                  {/* Invoice Date */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Invoice Date <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker"]}
                        sx={{ mt: -1 }}
                      >
                        <DatePicker
                          value={startDate}
                          onChange={(date) => handleStartDateChange(date)}
                          sx={{
                            width: "100%",
                            backgroundColor: "#f9f9f9",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#e0e0e0",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#bdbdbd",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1d82f5",
                            },
                            "& .MuiSvgIcon-root": {
                              color: "#757575",
                            },
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>

                  {/* Due Date */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Due Date <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer
                        components={["DatePicker"]}
                        sx={{ mt: -1,color: "#000000" }}
                      >
                        <DatePicker
                          value={dueDate}
                          onChange={(date) => handleDueDateChange(date)}
                          sx={{
                            width: "100%",
                            backgroundColor: "#f9f9f9",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#e0e0e0",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#bdbdbd",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1d82f5",
                            },
                            "& .MuiSvgIcon-root": {
                              color: "#757575",
                            },
                            color: "#000000",
                          }}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
                  </Grid>

                  {/* Currency */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",color: "#000000"
                      }}
                    >
                      Currency <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        value={currencyItem}
                        onChange={(e) => setCurrencyItem(e.target.value)}
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                          color: "#000000"
                        }}
                        renderValue={(selected) => {
                          if (selected.length === 0) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select currency
                              </em>
                            );
                          }
                          const selectedCurrency = currencyValue.find(
                            (item) => item.is_default === selected
                          );
                          return selectedCurrency
                            ? selectedCurrency.currency_code
                            : selected;
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          <em>Select currency</em>
                        </MenuItem>
                        {currencyValue.map((item) => (
                          <MenuItem
                            value={item.is_default}
                            key={item.id}
                            sx={{ fontFamily: "Ubuntu, sans-serif", }}
                          >
                            {item.currency_code}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Calculate Tax */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Calculate Tax <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        value={taxType}
                        onChange={(e) =>
                          setTaxType(parseInt(e.target.value, 10))
                        }
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",color: "#000000",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select tax calculation method
                              </em>
                            );
                          }
                          return selected === 1
                            ? "After Discount"
                            : "Before Discount";
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          <em>Select tax calculation method</em>
                        </MenuItem>
                        <MenuItem
                          value={1}
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          After Discount
                        </MenuItem>
                        <MenuItem
                          value={2}
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          Before Discount
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Client Details */}
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#212121",
                        mt: 2,
                        mb: 2,
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Client Details
                    </Typography>
                  </Grid>

                  {/* Client Name */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Client <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <TextField
                      fullWidth
                      value={clientData?.app_user?.username || ""}
                      InputProps={{
                        readOnly: true,
                        sx: {
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "& .MuiInputBase-input": {
                            // Add this
                            color: "#333", // Dark text color
                          },
                          "& .MuiInputLabel-root": {
                            // Add this
                            color: "#666",
                          },
                          "& .MuiInputBase-input::placeholder": {
                            // Add this
                            color: "#666",
                            opacity: 0.8,
                          },
                          color: "#000000",
                        },
                      }}
                    />
                  </Grid>

                  {/* Payment Details */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Payment Details <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        value={payDetail}
                        onChange={(e) =>
                          setPayDetail(parseInt(e.target.value, 10))
                        }
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                          color: "#000000",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select payment mode
                              </em>
                            );
                          }
                          return selected === 1
                            ? "Offline Mode"
                            : "Online Mode";
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          <em>Select payment mode</em>
                        </MenuItem>
                        <MenuItem
                          value={1}
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          Offline Mode
                        </MenuItem>
                        <MenuItem
                          value={2}
                          sx={{ fontFamily: "Ubuntu, sans-serif" }}
                        >
                          Online Mode
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Generated By */}
                  <Grid item xs={12} md={4}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Generated By <span style={{ color: "red" }}>*</span>
                    </Typography>
                    <FormControl fullWidth>
                      <Select
                        value={locationValue}
                        onChange={(e) => setLocationValue(e.target.value)}
                        displayEmpty
                        sx={{
                          backgroundColor: "#f9f9f9",
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e0e0e0",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#bdbdbd",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#1d82f5",
                          },
                          fontFamily: "Ubuntu, sans-serif",
                          color: "#000000",
                        }}
                        renderValue={(selected) => {
                          if (!selected) {
                            return (
                              <em
                                style={{
                                  color: "#757575",
                                  fontFamily: "Ubuntu, sans-serif",
                                }}
                              >
                                Select business location
                              </em>
                            );
                          }
                          return selected;
                        }}
                      >
                        <MenuItem
                          disabled
                          value=""
                          sx={{ fontFamily: "Ubuntu, sans-serif",color: "#000000" }}
                        >
                          <em>Select business location</em>
                        </MenuItem>
                        {businessLocation.map((item) => (
                          <MenuItem
                            value={item.location}
                            key={item.id}
                            sx={{ fontFamily: "Ubuntu, sans-serif" }}
                          >
                            {item.location}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  {/* Billing Address */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Billing Address
                    </Typography>
                    <TextareaAutosize
                      aria-label="billing address"
                      minRows={2}
                      maxRows={4}
                      value={clientData?.client?.company_address || ""}
                      readOnly
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderColor: "#e0e0e0",
                        borderRadius: "4px",
                        fontFamily: "Ubuntu, sans-serif",
                        backgroundColor: "#f9f9f9",
                        
                      }}
                    />
                  </Grid>

                  {/* Shipping Address */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Shipping Address
                    </Typography>
                    <TextareaAutosize
                      aria-label="shipping address"
                      minRows={2}
                      maxRows={4}
                      placeholder="Enter shipping address"
                      value={shippingAddress}
                      onChange={handleAddressChange}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderColor: "#e0e0e0",
                        borderRadius: "4px",
                        fontFamily: "Ubuntu, sans-serif",
                        backgroundColor: "#f9f9f9",
                        color: "#000000"
                      }}
                    />
                  </Grid>

                  {/* Invoice Items */}
                  <Grid item xs={12}>
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#212121",
                        mt: 2,
                        mb: 2,
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Invoice Items
                    </Typography>
                  </Grid>

                  <Grid item xs={12}>
                    <TableContainer
                      component={Paper}
                      sx={{ backgroundColor: "#f9f9f9",color: "#000000" }}
                    >
                      <Table>
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#333",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Description
                            </TableCell>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#333",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Quantity
                            </TableCell>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#333",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Unit Price
                            </TableCell>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#333",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Tax
                            </TableCell>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#333",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Amount
                            </TableCell>
                            <TableCell
                              sx={{
                                fontWeight: "bold",
                                color: "#333",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Action
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rows.map((row, index) => (
                            <React.Fragment key={index}>
                              <TableRow>
                                <TableCell>
                                  <Select
                                    value={items[index] || ""}
                                    onChange={(e) =>
                                      handleItemsChange(index, e.target.value)
                                    }
                                    displayEmpty
                                    fullWidth
                                    sx={{
                                      backgroundColor: "#fff",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#e0e0e0",
                                      },
                                      fontFamily: "Ubuntu, sans-serif",
                                    }}
                                    renderValue={(selected) => {
                                      if (!selected) {
                                        return (
                                          <em
                                            style={{
                                              color: "#757575",
                                              fontFamily: "Ubuntu, sans-serif",
                                            }}
                                          >
                                            Select Client's Drivers
                                          </em>
                                        );
                                      }
                                      return selected;
                                    }}
                                  >
                                    <MenuItem
                                      disabled
                                      value=""
                                      sx={{ fontFamily: "Ubuntu, sans-serif" }}
                                    >
                                      <em>Select Client's Drivers</em>
                                    </MenuItem>
                                    {Array.isArray(optionsValue) &&
                                    optionsValue.length > 0 ? (
                                      optionsValue.map((option) => {
                                        const imageUrl = `${
                                          config.apiImageUrl
                                        }${option?.app_user?.image || ""}`;
                                        return (
                                          <MenuItem
                                            key={
                                              option?.corp_driver?.id || index
                                            }
                                            value={
                                              option?.app_user?.username || ""
                                            }
                                            sx={{
                                              fontFamily: "Ubuntu, sans-serif",
                                            }}
                                          >
                                            <Box
                                              sx={{
                                                display: "flex",
                                                alignItems: "center",
                                              }}
                                            >
                                              <img
                                                src={
                                                  imageUrl ||
                                                  "/defaultDriverImage.png"
                                                }
                                                alt={
                                                  option?.app_user?.username ||
                                                  "Driver"
                                                }
                                                style={{
                                                  width: 30,
                                                  height: 30,
                                                  borderRadius: "50%",
                                                  marginRight: 10,
                                                }}
                                              />
                                              <Box
                                                sx={{
                                                  display: "flex",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <Typography variant="body2">
                                                  {option?.app_user?.username ||
                                                    ""}
                                                </Typography>
                                                <Typography variant="caption">
                                                  {option.corp_driver
                                                    ?.driver_id || ""}
                                                </Typography>
                                              </Box>
                                            </Box>
                                          </MenuItem>
                                        );
                                      })
                                    ) : (
                                      <MenuItem
                                        disabled
                                        sx={{
                                          fontFamily: "Ubuntu, sans-serif",
                                        }}
                                      >
                                        No drivers available
                                      </MenuItem>
                                    )}
                                  </Select>
                                </TableCell>
                                <TableCell>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <TextField
                                      type="number"
                                      value={row.quantity}
                                      onChange={(e) =>
                                        handleInputChange(
                                          index,
                                          "quantity",
                                          e.target.value
                                        )
                                      }
                                      fullWidth
                                      placeholder="1"
                                      size="small"
                                      sx={{
                                        backgroundColor: "#fff",
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          borderColor: "#e0e0e0",
                                        },
                                        color: "#000000",
                                        
                                      }}
                                    />
                                    <Select
                                      value={row.unit}
                                      onChange={(e) =>
                                        handleInputChange(
                                          index,
                                          "unit",
                                          e.target.value
                                        )
                                      }
                                      size="small"
                                      sx={{
                                        ml: 1,
                                        width: "80px",
                                        backgroundColor: "#fff",
                                        "& .MuiOutlinedInput-notchedOutline": {
                                          borderColor: "#e0e0e0",
                                        },
                                        color: "#000000",
                                      }}
                                    >
                                      <MenuItem value="1">Days</MenuItem>
                                      <MenuItem value="2">Pcs</MenuItem>
                                      <MenuItem value="3">Km</MenuItem>
                                    </Select>
                                  </Box>
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    type="number"
                                    value={row.unitPrice}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "unitPrice",
                                        e.target.value
                                      )
                                    }
                                    fullWidth
                                    placeholder="0.00"
                                    size="small"
                                    sx={{
                                      backgroundColor: "#fff",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#e0e0e0",
                                      },
                                      color: "#000000",
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <Select
                                    multiple
                                    value={row.tax}
                                    onChange={(e) =>
                                      handleInputChange(
                                        index,
                                        "tax",
                                        e.target.value
                                      )
                                    }
                                    fullWidth
                                    displayEmpty
                                    size="small"
                                    sx={{
                                      backgroundColor: "#fff",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#e0e0e0",
                                      },
                                      color: "#000000",
                                    }}
                                    renderValue={(selected) => {
                                      if (selected.length === 0) {
                                        return (
                                          <em style={{ color: "#757575" }}>
                                            Select Tax
                                          </em>
                                        );
                                      }
                                      return selected
                                        .map(
                                          (id) =>
                                            taxOptions.find(
                                              (option) => option.id === id
                                            )?.label
                                        )
                                        .join(", ");
                                    }}
                                  >
                                    {taxOptions.length > 0 ? (
                                      taxOptions.map((taxOption) => (
                                        <MenuItem
                                          key={taxOption.id}
                                          value={taxOption.id}
                                        >
                                          <Checkbox
                                            checked={
                                              row.tax.indexOf(taxOption.id) > -1
                                            }
                                          />
                                          <ListItemText
                                            primary={taxOption.label}
                                          />
                                        </MenuItem>
                                      ))
                                    ) : (
                                      <MenuItem disabled>
                                        No tax options available
                                      </MenuItem>
                                    )}
                                  </Select>
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    value={row.amount}
                                    InputProps={{ readOnly: true }}
                                    fullWidth
                                    size="small"
                                    sx={{
                                      backgroundColor: "#fff",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#e0e0e0",
                                      },
                                      color: "#000000",
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <IconButton
                                    onClick={() => removeRow(index)}
                                    color="error"
                                    size="small"
                                  >
                                    <RemoveCircleOutline />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell colSpan={5}>
                                  <TextField
                                    multiline
                                    value={descriptions[index] || ""}
                                    onChange={(e) =>
                                      handleDescriptionChange(
                                        index,
                                        e.target.value
                                      )
                                    }
                                    placeholder="Enter Description"
                                    fullWidth
                                    size="small"
                                    sx={{
                                      backgroundColor: "#fff",
                                      "& .MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#e0e0e0",
                                      },
                                      color: "#000000"
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  <label
                                    htmlFor={`file-upload-${index}`}
                                    style={{
                                      cursor: "pointer",
                                      display: "inline-block",
                                      padding: "6px 12px",
                                      color: "#1d82f5",
                                      border: "1px solid #e0e0e0",
                                      borderRadius: "4px",
                                      backgroundColor: "#fff",
                                      fontFamily: "Ubuntu, sans-serif",
                                      fontSize: "0.875rem",
                                    }}
                                  >
                                    Choose File
                                  </label>
                                  <input
                                    id={`file-upload-${index}`}
                                    type="file"
                                    onChange={(e) =>
                                      handleFileChangeMain(index, e)
                                    }
                                    style={{ display: "none" }}
                                  />
                                  {files[index] && (
                                    <Typography
                                      variant="caption"
                                      display="block"
                                      mt={1}
                                    >
                                      {files[index].name}
                                    </Typography>
                                  )}
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>

                  {/* Add Item Button */}
                  <Grid item xs={12}>
                    <Button
                      startIcon={<AddCircleOutline />}
                      onClick={addRow}
                      sx={{
                        color: "#1d82f5",
                        fontWeight: 500,
                        "&:hover": {
                          backgroundColor: "rgba(29, 130, 245, 0.04)",
                        },
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Add Item
                    </Button>
                  </Grid>

                  {/* Summary Table */}
                  <Grid item xs={12} md={6} sx={{ ml: "auto" }}>
                    <TableContainer>
                      <Table>
                        <TableBody>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: 500,
                                color: "#212121",
                                border: 0,
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Sub Total
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{
                                fontWeight: 500,
                                color: "#212121",
                                border: 0,
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Rs. {subtotal.toFixed(2)}
                            </TableCell>
                          </TableRow>
                          <TableRow>
                            <TableCell
                              sx={{
                                fontWeight: 500,
                                color: "#212121",
                                border: 0,
                                fontFamily: "Ubuntu, sans-serif",
                
                              }}
                            >
                              Discount
                            </TableCell>
                            <TableCell align="right" sx={{ border: 0 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "flex-end",
                                }}
                              >
                                <TextField
                                  type="number"
                                  value={discountValue}
                                  onChange={(e) =>
                                    setDiscountValue(e.target.value)
                                  }
                                  placeholder="0"
                                  size="small"
                                  sx={{
                                    width: "100px",
                                    mr: 1,
                                    backgroundColor: "#fff",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "#e0e0e0",
                                    },
                                    color: "#000000"
                                  }}
                                />
                                <Select
                                  value={discountType}
                                  onChange={(e) =>
                                    setDiscountType(e.target.value)
                                  }
                                  size="small"
                                  sx={{
                                    width: "100px",
                                    mr: 1,
                                    backgroundColor: "#fff",
                                    "& .MuiOutlinedInput-notchedOutline": {
                                      borderColor: "#e0e0e0",
                                    },
                                    color: "#000000"
                                  }}
                                >
                                  <MenuItem value="1">%</MenuItem>
                                  <MenuItem value="2">Amount</MenuItem>
                                </Select>
                                <Typography
                                  variant="body1"
                                  sx={{ fontFamily: "Ubuntu, sans-serif",color: "#000000" }}
                                >
                                  Rs. {discountValue || "0"}
                                </Typography>
                              </Box>
                            </TableCell>
                          </TableRow>
                          <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                            <TableCell
                              sx={{
                                fontWeight: 600,
                                color: "#212121",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Total
                            </TableCell>
                            <TableCell
                              align="right"
                              sx={{
                                fontWeight: 600,
                                color: "#212121",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Rs. {total}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>

                  {/* Note and Terms */}
                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Note for the recipient
                    </Typography>
                    <TextareaAutosize
                      minRows={2}
                      placeholder="Add a note for the recipient"
                      value={note}
                      onChange={handleNoteChange}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderColor: "#e0e0e0",
                        borderRadius: "4px",
                        backgroundColor: "#f9f9f9",
                        fontFamily: "Ubuntu, sans-serif",
                        color: "#000000",
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={6}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Terms and Conditions
                    </Typography>
                    <TextareaAutosize
                      minRows={2}
                      placeholder="Add terms and conditions"
                      value={terms}
                      onChange={handleTermsChange}
                      style={{
                        width: "100%",
                        padding: "10px",
                        borderColor: "#e0e0e0",
                        borderRadius: "4px",
                        backgroundColor: "#f9f9f9",
                        fontFamily: "Ubuntu, sans-serif",
                        color: "#000000",
                      }}
                    />
                  </Grid>

                  {/* File Upload */}
                  <Grid item xs={12}>
                    <Typography
                      variant="body1"
                      mb={1}
                      sx={{
                        color: "#212121",
                        fontFamily: "Ubuntu, sans-serif",
                      }}
                    >
                      Add File
                    </Typography>
                    <Box
                      sx={{
                        border: "1px dashed #bdbdbd",
                        borderRadius: 1,
                        p: 3,
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                        bgcolor: "#f9f9f9",
                      }}
                    >
                      {uploadFile ? (
                        <Box sx={{ width: "100%" }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              mb: 1,
                            }}
                          >
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              sx={{ fontFamily: "Ubuntu, sans-serif" }}
                            >
                              {uploadFile.name}
                            </Typography>
                            <IconButton
                              onClick={() => setUploadFile(null)}
                              size="small"
                              color="error"
                            >
                              <DeleteOutline />
                            </IconButton>
                          </Box>
                        </Box>
                      ) : (
                        <>
                          <input
                            type="file"
                            id="file-upload-main"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                          />
                          <label htmlFor="file-upload-main">
                            <Button
                              variant="text"
                              component="span"
                              startIcon={<AddPhotoAlternate />}
                              sx={{
                                color: "#1d82f5",
                                fontFamily: "Ubuntu, sans-serif",
                              }}
                            >
                              Upload File
                            </Button>
                          </label>
                          <Typography
                            variant="caption"
                            color="textSecondary"
                            sx={{ mt: 1, fontFamily: "Ubuntu, sans-serif",color: "#000000" }}
                          >
                            Click to upload or drag and drop
                          </Typography>
                        </>
                      )}
                    </Box>
                  </Grid>

                  {/* Payment Received Checkbox */}
                  <Grid item xs={12}>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Checkbox
                        checked={hide}
                        onChange={handleClickNew}
                        icon={<StyledCheckBoxOutlineBlankIcon />}
                        checkedIcon={<StyledCheckBoxIcon />}
                        sx={{
                          color: "#9e9e9e",
                          "&.Mui-checked": { color: "#1d82f5" },
                        }}
                      />
                      <Typography
                        variant="body1"
                        sx={{ fontFamily: "Ubuntu, sans-serif",color: "#000000" }}
                      >
                        I have received the payment
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Conditional Payment Fields */}
                  {hide && (
                    <>
                      <Grid item xs={12} md={4}>
                        <Typography
                          variant="body1"
                          mb={1}
                          sx={{
                            color: "#212121",
                            fontFamily: "Ubuntu, sans-serif",
                          }}
                        >
                          Payment Gateway
                        </Typography>
                        <FormControl fullWidth>
                          <Select
                            value={about}
                            onChange={(e) => setAbout(e.target.value)}
                            displayEmpty
                            sx={{
                              backgroundColor: "#f9f9f9",
                              "& .MuiOutlinedInput-notchedOutline": {
                                borderColor: "#e0e0e0",
                              },
                              fontFamily: "Ubuntu, sans-serif",
                            }}
                            renderValue={() => "Offline Payment"}
                          >
                            <MenuItem
                              value={true}
                              sx={{ fontFamily: "Ubuntu, sans-serif" }}
                            >
                              Offline Payment
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} md={4}>
                        <Typography
                          variant="body1"
                          mb={1}
                          sx={{
                            color: "#212121",
                            fontFamily: "Ubuntu, sans-serif",
                          }}
                        >
                          Transaction ID <span style={{ color: "red" }}>*</span>
                        </Typography>
                        <TextField
                          fullWidth
                          placeholder="Enter the Transaction ID of payments"
                          sx={{
                            backgroundColor: "#f9f9f9",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#e0e0e0",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#bdbdbd",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#1d82f5",
                            },
                          }}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Box>

              {/* Save Buttons */}
              <Box display="flex" gap={2} mt={3}>
                <Button
                  variant="contained"
                  onClick={handleClick1}
                  sx={{
                    bgcolor: "#4285F4",
                    color: "white",
                    "&:hover": { bgcolor: "#3367D6" },
                    fontWeight: 500,
                    textTransform: "none",
                    padding: "8px 16px",
                    fontFamily: "Ubuntu, sans-serif",
                  }}
                >
                  Save
                </Button>
                <Menu
                  anchorEl={anchorEl1}
                  open={open1}
                  onClose={handleClose1}
                  sx={{ zIndex: 3000 }}
                >
                  <MenuItem
                    onClick={() => {
                      handleSaveInvoice(1);
                      handleClose1();
                    }}
                    sx={{ fontFamily: "Ubuntu, sans-serif" }}
                  >
                    <SaveOutlined
                      fontSize="small"
                      sx={{ mr: 1, color: "#757575" }}
                    />
                    Save as Draft
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleSaveInvoice(2);
                      handleClose1();
                    }}
                    sx={{ fontFamily: "Ubuntu, sans-serif" }}
                  >
                    <SaveOutlined
                      fontSize="small"
                      sx={{ mr: 1, color: "#757575" }}
                    />
                    Save
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleSaveInvoice(3);
                      handleClose1();
                    }}
                    sx={{ fontFamily: "Ubuntu, sans-serif" }}
                  >
                    <Send fontSize="small" sx={{ mr: 1, color: "#757575" }} />
                    Save & Send
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleSaveInvoice(4);
                      handleClose1();
                    }}
                    sx={{ fontFamily: "Ubuntu, sans-serif" }}
                  >
                    <DoneAllOutlined
                      fontSize="small"
                      sx={{ mr: 1, color: "#4caf50" }}
                    />
                    Save & Mark as Sent
                  </MenuItem>
                </Menu>
                <Button
                  variant="outlined"
                  onClick={handleCloseModal}
                  sx={{
                    borderColor: "#bdbdbd",
                    color: "#424242",
                    "&:hover": {
                      borderColor: "#9e9e9e",
                      bgcolor: "rgba(0, 0, 0, 0.04)",
                    },
                    textTransform: "none",
                    padding: "8px 16px",
                    fontFamily: "Ubuntu, sans-serif",
                  }}
                >
                  Cancel
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Slide>
    </Modal>
  );
}
